<template>
  <v-container fluid fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" class="text-center">
        <v-progress-circular
          v-if="loading"
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <div v-if="loading" class="mt-4">
          <h3>Proxying into {{ username }}...</h3>
        </div>
        <div v-if="error">
          <v-alert type="error" prominent>
            <h3>Error</h3>
            <div>{{ error }}</div>
          </v-alert>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getMemberURL } from '@/helpers/memberProxyHelper';

export default {
  name: 'Proxy',
  data() {
    return {
      loading: true,
      error: null,
      username: null
    }
  },
  async mounted() {
    // Get username from query params
    this.username = this.$route.query.username;

    if (!this.username) {
      this.error = 'Missing username parameter';
      this.loading = false;
      return;
    }

    try {
      // Call the delegation endpoint to get the access token
      let res = await this.$axios.post('/admin/login', {
        grant_type: 'delegation',
        client_id: 'adminProxy',
        target_username: this.username
      });

      let token = res.data;
      const memberURL = getMemberURL();

      // Wait 1 second to let user see the "Proxying into..." message
      await new Promise(resolve => setTimeout(resolve, 1000));

      // Redirect to member portal with token
      window.location.href = `${memberURL}?token=${token.access_token}`;

    } catch (e) {
      console.error(e);
      this.error = e.response?.data?.message || 'Error proxying into the account';
      this.loading = false;
    }
  }
}
</script>

<style scoped>
</style>

